import React, { FC } from 'react'
import { inlineContent, inlineContentContainer } from './styles';
import { topline as toplineStyle } from '../../components/Layout/styles';
import { FlexBox } from '../FlexBox';

type InlineContentProps = {
    header?: string;
    topline?: string;
    text?: string;
    rightContent?: React.ReactNode;
}

const InlineContent: FC<InlineContentProps> = ({header, topline, text, rightContent}) => {
    return (
        <div css={inlineContentContainer}>
            <FlexBox direction='row' align='center' justify='space-between' gap='60px' changeToColumn>
                <div css={inlineContent}>
                    <div css={toplineStyle}>
                        {topline}
                    </div>
                    {header && <h2>{header}</h2>}
                    {text && <p>{text}</p>}
                </div>
                <div>
                    {rightContent}
                </div>
            </FlexBox>
        </div>
    )
}

export default InlineContent